import { Ref } from "react";

import BaseInput, { InputProps } from "./BaseInput";

import styles from "../../styles/TextArea.module.less";

type TextAreaProps = Omit<InputProps, "preIcon" | "status"> & {
  label: string;
  ref?: Ref<HTMLTextAreaElement>;
};

const TextArea = ({ className: containerClassName, label, ref, ...other }: TextAreaProps) => {
  return (
    <BaseInput
      styles={{ container: containerClassName }}
      {...other}
      renderInputDisplay={({ onChange, preIcon, status, className, ...inputProps }) => (
        <>
          <BaseInput.AnimationContainer label={label}>
            <textarea
              {...inputProps}
              ref={ref}
              className={`${className} ${styles.textarea}`}
              placeholder="" // Disable placeholders since the label sticks there when value is empty
              onChange={(event) => onChange(event.target.value)}
            />
          </BaseInput.AnimationContainer>
        </>
      )}
    />
  );
};

export default TextArea;
